import styled, {css} from 'styled-components';

import {colors, breakpoint} from 'theme';

export const ContentColumnsWrapper = styled.div`
    display: flex;
    gap: 40px;
    max-width: 980px;
    margin-bottom: 40px;
    margin-top: 36px;
    flex-wrap: wrap;
    @media (min-width: ${breakpoint.tablet}) {
        gap: 40px;
    }
`;
export const ContentColumn = styled.div`
    margin-bottom: 16px;
    max-width: 300px;
    min-width: 300px;
    flex: 1;
`;

export const ContentColumnElement = styled.div`
    margin-bottom: 16px;
`;

export const ContentColumnTypography = styled.div`
    font-size: 13px;
    line-height: 14px;
    margin-bottom: 6px;
`;
export const ContentColumnTitle = styled(ContentColumnTypography)`
    color: ${colors.textSecondary};
`;
export const ContentColumnText = styled(ContentColumnTypography)<{
    highlighted?: boolean;
    thin?: boolean;
}>`
    color: ${colors.textPrimary};
    ${(p) =>
        p.highlighted &&
        css`
            background: ${colors.brandLight};
            border-radius: 6px;
            padding: 6px 10px;
            width: fit-content;
            font-weight: 500;
        `}
    ${(p) =>
        p.thin &&
        css`
            padding: 0 10px;
        `}
`;
